
export function modWrap(a:number, b:number){
    return a - b * Math.floor(a/b);
}
